import React from "react";

export const FormErrors = ({ formErrors, field }) => (
  <div className="formErrors">
    {Object.keys(formErrors).map((fieldName, i) => {
      if (formErrors[fieldName].length > 0 && field === fieldName) {
        return <p key={i}>{formErrors[fieldName]}</p>;
      } else {
        return "";
      }
    })}
  </div>
);
